import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { registrationApi } from "../api/registrationApi";
// const qrRegex = /^[0-9a-f]{32}$/;
export const useEventRegistrations = (eventId, params) => {
  const queryKey = ["/registrations", eventId, params];

  const { data, isLoading, error, refetch } = useQuery({
    queryKey,
    queryFn: async () => await registrationApi.getByEvent(eventId, params),
    enabled: !!eventId,
    refetchInterval: 30000, // Tự động refetch mỗi 30 giây
  });

  return {
    data: data?.data || [],
    pagination: data?.pagination || {
      page: 1,
      limit: 10,
      total: 0,
      totalPages: 0,
    },
    loading: isLoading,
    error,
    refetch,
  };
};

export const useCheckInInfo = (qrCode, eventId) => {
  const queryKey = ["/check-in-info", qrCode, eventId];
  const { data, isLoading, error } = useQuery({
    queryKey,
    queryFn: async () => await registrationApi.getCheckInInfo(qrCode, eventId),
    enabled: !!eventId && !!qrCode && qrCode.length === 32,
  });

  console.log("data_main: ", data);

  return {
    data,
    isLoading,
    error,
  };
};

export const useCheckIn = () => {
  const queryClient = useQueryClient();

  const checkInManual = useMutation({
    mutationFn: async (registrationId) =>
      await registrationApi.checkInManual(registrationId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["/registrations"] });
    },
  });

  const checkInQR = useMutation({
    mutationFn: async (qrCode) => await registrationApi.checkInQR(qrCode),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ["/registrations"] }),
  });

  const checkOutQR = useMutation({
    mutationFn: async (qrCode) => await registrationApi.checkOutQR(qrCode),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ["/registrations"] }),
  });

  const updateStatus = useMutation({
    mutationFn: async ({ id, status, note }) =>
      await registrationApi.updateStatus(id, { status, note }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["/registrations"] });
    },
  });

  const deleteRegistration = useMutation({
    mutationFn: async (id) => await registrationApi.remove(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["/registrations"] });
    },
  });

  const updateIsTakingRefuge = useMutation({
    mutationFn: async ({ id, isTakingRefuge }) =>
      await registrationApi.updateIsTakingRefuge(id, isTakingRefuge),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["/registrations"] });
    },
  });

  const adminAddUserToEvent = useMutation({
    mutationFn: async ({ eventId, userId, isTakingRefuge }) =>
      await registrationApi.adminAddUserToEvent(eventId, { userId, isTakingRefuge }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["/registrations"] });
    },
  });

  return {
    checkInManual,
    checkInQR,
    checkOutQR,
    updateStatus,
    deleteRegistration,
    updateIsTakingRefuge,
    adminAddUserToEvent,
  };
};
